import {combineReducers} from 'redux'
import certificateReducer from './certificate';

export const rootReducers = combineReducers({
    certificate: certificateReducer,
  });

